const dateSelector = (newTargetDate) => {
    return dispatch => {
        dispatch({type: 'NEW_TARGET_DATE', targetDate: newTargetDate});
    }
}
export { dateSelector }